import React, { useMemo, useRef, useState } from "react";
import styled, { css } from "styled-components";
import { colors2, List, transition, UI_BODY_SM_DF, useHandleClickOutside } from "oolib";
import { ButtonGhost, ButtonPrimary } from "oolib/dist/v2/components/Buttons";

import { useAddableWidgetsBaseConfs } from "../../CONFIG";
import { GRID_GAP, TOTAL_COLUMNS } from "../../constants";
import { handleAddWidget } from "../../utils/handleAddWidget";
import { ADD_WIDGET_BTN_LEFT_RIGHT_SPACE, ADD_WIDGET_BTN_SECONDARY_HEIGHT, ADD_WIDGET_BTN_WIDTH, ADD_WIDGET_BTN_WIDTH_EMPTY_SCREEN, WIDGET_WRAPPER_PADDING } from "../..";
import { Z_INDEX } from "../../styled";
import { useReportConfig } from "../../ReportLandingContext";

const StyledAddWidgetButtonWrapper = styled.div`
`;

const StyledButtonGhost = styled(ButtonGhost)`
  ${({ variant, isEmptyScreen }) => 
    variant === "primary"
      ? css`
        height: 100%;
        min-height: ${isEmptyScreen ? ADD_WIDGET_BTN_WIDTH_EMPTY_SCREEN : ADD_WIDGET_BTN_WIDTH}px;
        border-radius: 1.9rem;
        width: ${isEmptyScreen ? ADD_WIDGET_BTN_WIDTH_EMPTY_SCREEN : ADD_WIDGET_BTN_WIDTH}px;
        justify-content: center;
        .widget-row-container:hover &,
        .row-hovered & {
          background-color: white !important;
        }
      `
      : css`
        height: ${ADD_WIDGET_BTN_SECONDARY_HEIGHT}px;
        min-height: ${ADD_WIDGET_BTN_SECONDARY_HEIGHT}px;
        width: 100%;
        border-radius: 1.2rem;
        justify-content: flex-start;
        padding: 0 1.6rem;
        border: 1px solid ${colors2.grey10};
        color: ${colors2.grey80};
        background: ${colors2.white};
        
        @media (hover: hover) {
          &:hover {
            color: ${colors2.onSecondary};
            border-color: ${colors2.onSecondary};
            
            &::before {
              content: "";
              background-color: transparent;
              position: absolute;
              top: 0;
              border-radius: inherit;
              left: 0;
              right: 0;
              bottom: 0;
              /* z-index: 1; */
            }
            
            &:hover::before {
              background: ${colors2.secondaryContainer};
            }
          }
        }

      `
  }


`

const StyledListWrapper = styled.div`
  z-index: ${Z_INDEX.ADD_WIDGET_BTN_PRIMARY};
  ${({ variant }) => variant === "primary" 
    ? css`
      position: absolute;
      right: -${GRID_GAP}px;
      top: 50%;
      transform: translate(100%);
      min-width: 175px;
    `
    : css`
      position: absolute;
      ${({ position }) => position === "top" ? 
        css`
          bottom: ${ADD_WIDGET_BTN_SECONDARY_HEIGHT + GRID_GAP}px;
      ` : css`
          top: ${ADD_WIDGET_BTN_SECONDARY_HEIGHT + GRID_GAP}px;
      `}
      left: 0;
      min-width: 175px;
    `
  }
`

export const AddWidgetButton = ({
  currentFirstWidgetInRow,
  widgetIndex,
  setUnderEditWidgetId,
  isNewRow,
  style = {},
  isEmptyScreen,
  variant = "primary"
}) => {
  const { config, setConfig } = useReportConfig();
  const addableWidgetsBaseConfs = useAddableWidgetsBaseConfs();
  const [showList, setShowList] = useState(false);
  const listRef= useRef(null);
  const buttonWrapperRef= useRef(null);
  useHandleClickOutside([listRef], setShowList)

  const buttonPosition = variant === "secondary" ? buttonWrapperRef?.current?.getBoundingClientRect()?.top < 500 ? "bottom" : "top" : undefined

  return (
    
      <div
        ref={buttonWrapperRef}
        style={{
          position: variant === "primary" ? "absolute" : "relative",
          left: variant === "primary" ? - ADD_WIDGET_BTN_LEFT_RIGHT_SPACE + (isEmptyScreen ? (ADD_WIDGET_BTN_WIDTH_EMPTY_SCREEN - ADD_WIDGET_BTN_WIDTH) : 0) : 0,
          transform: variant === "primary" ? "translateX(-100%)" : "none",
          zIndex: variant === "primary" ? Z_INDEX.ADD_WIDGET_BTN_PRIMARY : Z_INDEX.ADD_WIDGET_BTN_SECONDARY,
          top: 0,
          // left: - WIDGET_WRAPPER_PADDING + "px",
          ...style,
        }}
        // onMouseOut={() => setShowList(false)}
      >
        {showList && (
          <StyledListWrapper
            variant={variant}
            ref={listRef}
            position={buttonPosition} // only needed for secondary variant
          >
            <List 
              options={addableWidgetsBaseConfs} 
              onChange={(id, newWidgetBaseConf) => {
                const { newWidgetId } = handleAddWidget({
                  currentFirstWidgetInRow,
                  widgetIndex,
                  config,
                  setConfig,
                  isNewRow,
                  newWidgetBaseConf,
                  TOTAL_COLUMNS,
                });
                setUnderEditWidgetId(newWidgetId);
                setShowList(false);
              }}
              value={addableWidgetsBaseConfs[currentFirstWidgetInRow]} 
              style={{ textWrap: "nowrap" }}
            />
          </StyledListWrapper>
        )}
       
        <StyledButtonGhost
          onClick={() => setShowList((prev) => !prev)}
          S
          icon="Plus"
          isEmptyScreen={isEmptyScreen}
          variant={variant}
          children={variant === "primary" ? null : "Add Widget"}
        />
       
      </div>
   
  );
};
